
import BasePostGrid from '@PegasusCore/pegasus-one-post-grid/src/script.js';

class PostGrid extends BasePostGrid {
    showAllPosts = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('postGrid', () => new PostGrid());
});